export default __webpack_public_path__ + "static/media/BaruSymbolHeader.96ba1fc9.svg";